<template>
    <div class="top_con">
       <el-form :inline="true" :model="formInline" class="demo-form-inline">
           <el-row :gutter="10">
                <el-form-item label="账户">
                    <el-input v-model="formInline.username" placeholder="请输入"></el-input>
                </el-form-item>
                <div style="float:right;">
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" @click="clearSum">重置</el-button>
                    </el-form-item>
                </div>
           </el-row>
        </el-form>
        <el-button type="primary" @click="look(0)" style="margin-top:20px;" v-if="user.roleId!=3">添加用户</el-button>
        <el-table  ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" max-height="580px">
            <el-table-column  prop="newId"  label="ID"></el-table-column>
            <el-table-column  prop="username"  label="账户"></el-table-column>
             <el-table-column prop="password"  label="密码"></el-table-column>
            <el-table-column  prop="tel"  label="联系电话"></el-table-column>
            <el-table-column prop="role"  label="账户权限" ></el-table-column>
            <el-table-column   label="操作">
                <template slot-scope="scope">
                    <el-link :underline="false" @click="look(2,scope.row.id)" style="margin-right:20px;" v-if="user.roleId!=3">编辑</el-link>
                    <el-link :underline="false" @click="del(scope.row.id)" type="danger" style="margin-right:20px;" v-if="user.roleId==1">删除</el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  background layout="prev, pager, next"  :pager-count="5" :page-size="value" :total='total' @current-change="handleCurrentChange"></el-pagination>
        <div>
            <el-dialog :title="zp_tit" :visible.sync="dialogFormVisible" width="50%">
                <el-form :model="form"  :rules="rules" ref="form" label-width="100px">
                    <el-row :gutter="8">
                        <el-col :span="10">
                            <el-form-item label="账户" prop="username">
                                <el-input v-model="form.username" placeholder="请输入" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                         <el-col :span="10">
                            <el-form-item label="密码" prop="password">
                                <el-input v-model="form.password" placeholder="请输入" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="8">
                        <el-col :span="10">
                            <el-form-item label="手机号">
                                <el-input v-model="form.tel" type="number" placeholder="请输入" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="角色" prop="role">
                                <el-select v-model="form.role" placeholder="请选择" :disabled="tit_type==1?true:false" @change="editID">
                                    <el-option label="超级管理员" value="1"></el-option>
                                    <el-option label="管理员"  value="2"></el-option>
                                    <el-option label="普通用户"  value="3"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div slot="footer" class="dialog-footer" style="text-align:center;" v-if="tit_type!=1">
                    <el-button type="primary" @click="subAdd" v-if="tit_type==0">确认添加</el-button>
                    <el-button type="primary" @click="subEdit" v-if="tit_type==2">确认修改</el-button>
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import {userInfo,userAdd,userXinXi,userEdit,userDel} from '@/utils/api'
export default {
    data(){
        return{
            user:{},
            userId:'',
            formInline: {
                username: ''
            },
            dialogFormVisible:false,
            zp_tit:"添加用户",
            tit_type:0,
            form:{
                tel:'',
                username:'',
                password:'',
                role:'',
                roleid:'',
            },
            rules: {
                username: [
                    { required: true, message: '请输入账户名称', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入账户密码', trigger: 'blur' }
                ],
                role: [
                    { required: true, message: '请选择账户权限', trigger: 'change' }
                ],
            },
            formLabelWidth: '120px',
            value:10,
            total:12,
            pageNum:1,
            multipleSelection:[],
            tableData: [],
        }
    },
    methods:{
        handleCurrentChange(val){
            this.pageNum=val;
            let param ={
                numPerPage:this.value,
                pageNum:val,
                formInline:this.formInline
            }
            userInfo(param).then(res=>{
                this.total=res.total;
                this.tableData=res.list
            });
        },
        onSubmit(){
            let param ={
                numPerPage:this.value,
                pageNum:1,
                formInline:this.formInline
            }
            userInfo(param).then(res=>{
                this.total=res.total;
                this.tableData=res.list
            });
        },
        clearSum(){
            this.formInline={}
            userInfo().then(res=>{
                this.total=res.total;
                this.tableData=res.list
            });
        },
        look(idx,id){
            this.dialogFormVisible=true
            if(idx==0){
                this.form={};
                this.zp_tit="添加用户";
                this.tit_type=0;
                this.form={}
            }else if(idx==1){
                this.zp_tit="查看详情";
                this.tit_type=1;
                userXinXi({id:id}).then(res=>{
                    this.form=res;
                });
            }else if(idx==2){
                this.zp_tit="编辑";
                this.tit_type=2;
                userXinXi({id:id}).then(res=>{
                    this.form=res;
                });
                this.userId=id;
            }
        },
        handleSelectionChange(val){
            this.multipleSelection = val;
        },
        subAdd(){
            this.form.roleid=this.form.role;
            this.user=JSON.parse(localStorage.getItem('userInfo'))
            let param ={
                userId:this.user.uid,
                formInline:this.form
            }
            console.log(this.form)
            if(this.form.username=='' || this.form.password=='' || this.form.role==''){
                this.$message({
                    type: 'info',
                    message: '请填写必填项'
                });     
            }else{
                userAdd(param).then(res=>{
                    userInfo().then(res=>{
                        this.dialogFormVisible=false
                        this.total=res.total;
                        this.tableData=res.list
                    });
                });
            }
            
        },
        editID(){
            this.form.roleid=this.form.role;
        },
        subEdit(){
            let param ={
                userId:this.user.uid,
                formInline:this.form
            }
            userEdit(param).then(res=>{
                userInfo().then(res=>{
                    this.dialogFormVisible=false
                    this.total=res.total,
                    this.tableData=res.list
                });
            });
        },
        del(id){
            this.$confirm('确定删除该条, 是否继续?', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    userDel({userId:this.user.uid,id:id}).then(res=>{
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        userInfo().then(res=>{
                            this.total=res.total;
                            this.tableData=res.list
                        });
                    });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        }
    },
    mounted(){
        this.user=JSON.parse(localStorage.getItem('userInfo'))
        userInfo().then(res=>{
            this.total=res.total;
            this.tableData=res.list
        });
    }
}

</script>
<style scoped>
    .top_con{
        width:100%;
        height:auto;
        padding:20px;
        box-sizing:border-box;
    }
    .el-form-item{
        vertical-align:middle;
        margin-right:20px;
    }
    .el-input{
        /* width:193px; */
        margin-right:10px;
    }
    .el-pagination {
        text-align: right;
        margin-top: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/userGl.vue